import React from 'react';
import './Cont.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function Cont() {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <div className="Cont-section">
      <h1 className="Cont-title">{t.contTitle}</h1>
      <div className="Cont-img-wrap">
        <img src="/co.png" alt="Our Partners" />
      </div>
    </div>
  );
}

export default Cont;